import { runOnPage } from './general.js';
import cs from 'flatpickr/dist/l10n/cs';
import en from 'flatpickr/dist/l10n/default';
import 'flatpickr/dist/flatpickr.min.css';

runOnPage('contact-default', () => {
	$(function () {

		const lang       = document.documentElement.lang || 'en';
		const localeMap  = { cs: cs.default, en: en.default };

		$('.datepicker').flatpickr({
			dateFormat: 'Y-m-d',
			locale: localeMap[lang] || en.default,
			monthSelectorType: 'static',
			disableMobile: true,
		});

		const $jobFields       = $('#job-fields');
		const $collabFields    = $('#collaboration-fields');
		const $positionFields  = $('#position-fields');

		function toggleSections(value) {
			if (value === 'job') {
				$jobFields.show();
				$positionFields.show();
				$collabFields.hide();
			} else if (value === 'collaboration') {
				$collabFields.show();
				$jobFields.hide();
				$positionFields.hide();
			} else {
				$jobFields.hide();
				$collabFields.hide();
				$positionFields.hide();
			}
		}

		function toggleActiveButtons(name, value) {
			$(`input[name="${name}"]`).each(function () {
				$(this).closest('label')
					.removeClass('bg-deepvision-600 text-deepvision-100');
			});
			$(`input[name="${name}"][value="${value}"]`).each(function () {
				$(this).closest('label')
					.addClass('bg-deepvision-600 text-deepvision-100');
			});
		}

		$('input[name="type"]').on('change', function () {
			const value = $(this).val();
			toggleSections(value);
			toggleActiveButtons('type', value);
		});

		$('input[name="source"]').on('change', function () {
			toggleActiveButtons('source', $(this).val());
		});

		$('input[name="position"]').on('change', function () {
			toggleActiveButtons('position', $(this).val());
		});

		const $typeInput  = $('input[name="type"]:checked, input[type="hidden"][name="type"]');
		const initialType = $typeInput.val() || '';
		const initialSource  = $('input[name="source"]:checked').val() || '';
		const initialPos     = $('input[name="position"]:checked').val() || '';

		toggleSections(initialType);
		toggleActiveButtons('type', initialType);
		toggleActiveButtons('source', initialSource);
		toggleActiveButtons('position', initialPos);

		$('.custom-file-input').on('change', function () {
			const $input     = $(this);
			const file       = this.files[0];
			const inputId    = $input.attr('id');
			const $label     = $(`label[for="${inputId}"]`);
			const $textSpan  = $label.find('.custom-file-button-text');
			const defaultTxt = $textSpan.data('default') || 'Choose file';

			if (file) {
				$textSpan.text(file.name).attr('title', file.name);
			} else {
				$textSpan.text(defaultTxt).removeAttr('title');
			}
		});
	});
});
